const SERVICE_REQUIREMENT_ALIASES: Record<string, string> = {
  dtd: "dtd",
  dtp: "dtp",
  ptd: "ptd",
  ptp: "ptp",
  door_to_door: "dtd",
  door_to_port: "dtp",
  port_to_door: "ptd",
  port_to_port: "ptp",
};

export const resolveServiceRequirementIconKey = (
  ...candidates: Array<string | undefined | null>
): string | undefined =>
  candidates
    .map((candidate) => {
      if (!candidate) {
        return undefined;
      }

      const normalized = candidate.trim().toLowerCase().replace(/[\s-]+/g, "_");
      return SERVICE_REQUIREMENT_ALIASES[normalized];
    })
    .find(Boolean);
